// extracted by mini-css-extract-plugin
module.exports = {"content":"DoorAccess_content__SxIZT","headerContainer":"DoorAccess_headerContainer__2QnRh","cell":"DoorAccess_cell__XV5p4"};